const SEGMENTATION_AFILIO = 'AFILIO';
const SEGMENTATION_BET = 'BET';

/** Variantes de host só para segmentação BET. Demais segmentações ignoram este campo. */
const MASTERTAG_HOST_BETCONNECT = 'betconnect';
const MASTERTAG_HOST_BCONNECT = 'bconnect';

const MASTERTAG_PUBLIC_SCRIPT_HOST_BETCONNECT = 'https://m.betconnect.com.br';
const MASTERTAG_PUBLIC_SCRIPT_HOST_BCONNECT = 'https://bconnect.com.br';
const MASTERTAG_PUBLIC_SCRIPT_HOST_V3 = 'https://mtag.afilio.com.br';

/**
 * Host público dos scripts (tag script src) no site do anunciante.
 * BET: betconnect -> m.betconnect.com.br; bconnect -> bconnect.com.br.
 * Demais segmentações (AFILIO, CJ, TAGVC, MEDIATIQUE...) -> mtag.afilio.com.br.
 */
function mastertagPublicScriptHost(segmentation, hostType) {
  if (segmentation === SEGMENTATION_BET) {
    if (hostType === MASTERTAG_HOST_BCONNECT || hostType === 'other') {
      return MASTERTAG_PUBLIC_SCRIPT_HOST_BCONNECT;
    }

    return MASTERTAG_PUBLIC_SCRIPT_HOST_BETCONNECT;
  }

  return MASTERTAG_PUBLIC_SCRIPT_HOST_V3;
}

function normalizeMastertagHostType(hostType) {
  if (hostType === MASTERTAG_HOST_BCONNECT || hostType === 'other') {
    return MASTERTAG_HOST_BCONNECT;
  }

  return MASTERTAG_HOST_BETCONNECT;
}

/**
 * BET -> MASTERTAGGO (DB mastertag), partner 2.
 * Todas as outras segmentações -> MASTERTAGGO_V3 (mastertagv3db), partner 1 (mesma regra de negócio que Afilio).
 */
function mastertagRouting(segmentation) {
  const segmentationId = segmentation && typeof segmentation === 'object'
    ? segmentation.id ?? segmentation.value ?? segmentation.name
    : segmentation;
  if (String(segmentationId || '').toUpperCase() === SEGMENTATION_BET) {
    return { serviceApp: 'MASTERTAGGO', partnerId: 2 };
  }

  return { serviceApp: 'MASTERTAGGO_V3', partnerId: 1 };
}

// function mastertagUserHeaders(userId) {
//   if (userId == null || userId === '') {
//     return {};
//   }

//   return { 'X-User-Id': String(userId) };
// }

export default {
  methods: {
    async getScripts(campaignId, siteId, segmentation) {
      const { serviceApp } = mastertagRouting(segmentation);
      return await this.$http.get(
        `/redirect?app=${serviceApp}&path=/api/v1/partner/configs?progid=${campaignId}%26siteid=${siteId}`
      );
    },

    async createScript(campaignId, type, siteId, template, segmentation) {
      const { serviceApp, partnerId } = mastertagRouting(segmentation);
      return await this.$http.post(
        `/v2/redirect`,
        {
          app: serviceApp,
          path: '/api/v1/partner/configs',
          params: {
            data: {
              progid: Number.parseInt(campaignId, 10),
              type: type,
              siteid: siteId.toString(),
              partner: partnerId,
              script_template: template
            }
          }
        },
        // { headers: mastertagUserHeaders(userId) }
      );
    },

    async updateScript(script_template, script_id, segmentation) {
      const { serviceApp } = mastertagRouting(segmentation);
      return await this.$http.put(
        `/redirect`,
        {
          app: serviceApp,
          path: '/api/v1/partner/configs/' + script_id,
          params: JSON.stringify({ data: { script_template } })
        },
        // { headers: mastertagUserHeaders(userId) }
      );
    },

    async deleteScript(script_id, segmentation) {
      const { serviceApp } = mastertagRouting(segmentation);
      return await this.$http.delete(`/v2/redirect?app=${serviceApp}&path=/api/v1/partner/configs/${script_id}`);
    },

    async toggleScriptActive(script_id, new_status, segmentation) {
      const { serviceApp } = mastertagRouting(segmentation);
      return await this.$http.put(`/redirect`, {
        app: serviceApp,
        path: '/api/v1/partner/configs/' + script_id,
        params: JSON.stringify({ data: { active: new_status } })
      });
    },

    async updateScriptSriEnabled(script_id, sri_enabled, segmentation) {
      const { serviceApp } = mastertagRouting(segmentation);
      return await this.$http.put(`/redirect`, {
        app: serviceApp,
        path: '/api/v1/partner/configs/' + script_id,
        params: JSON.stringify({ data: { sri_enabled } })
      });
    },

    async getCampaignSri(progid, segmentation) {
      const { serviceApp } = mastertagRouting(segmentation);
      return await this.$http.get(
        `/redirect?app=${serviceApp}&path=/api/v1/partner/configs/campaign-sri?progid=${progid}`
      );
    },

    async putCampaignSri(progid, sri_campaign_allowed, segmentation) {
      const { serviceApp } = mastertagRouting(segmentation);
      return await this.$http.put(`/redirect`, {
        app: serviceApp,
        path: '/api/v1/partner/configs/campaign-sri',
        params: JSON.stringify({
          data: {
            progid: Number.parseInt(progid, 10),
            sri_campaign_allowed
          }
        })
      });
    },

    async getScriptPreviewWithSri(script_id, segmentation) {
      const { serviceApp } = mastertagRouting(segmentation);
      return await this.$http.get(
        `/redirect?app=${serviceApp}&path=/api/v1/partner/configs/${script_id}/preview?sri=1`
      );
    },

    async searchScriptsV2(campaignIdV3, campaignIdV2) {
      if (campaignIdV2) {
        return await this.$http.get(
          `/redirect?app=MASTERTAGGO&path=/api/v1/tag/configs?progid=${campaignIdV2}`
        );
      }
      if (campaignIdV3) {
        const response = await this.$http.get(
          `/redirect?app=ADVERTISER&path=/api/get/campaign/details/${campaignIdV3}`
        );
        const v2_id = response.data?.v2_id;
        if (!v2_id) {
          throw new Error('V2 ID não encontrado');
        }
        return await this.$http.get(
          `/redirect?app=MASTERTAGGO&path=/api/v1/tag/configs?progid=${v2_id}`
        );
      }
    },

    /**
     * Logs de scripts bloqueados na V2 (external_tag_blocked_log).
     * Sempre via mastertag-v3 (MASTERTAGGO_V3), que consulta o banco legado afilio.
     */
    async getBlockedLogsV2({ progid, op, from, to, limit = 50, offset = 0 } = {}) {
      const params = new URLSearchParams();
      if (progid) params.set('progid', String(progid));
      if (op) params.set('op', String(op));
      if (from) params.set('from', String(from));
      if (to) params.set('to', String(to));
      if (limit != null) params.set('limit', String(limit));
      if (offset != null) params.set('offset', String(offset));

      const qs = params.toString();
      const path = `/api/v1/partner/configs/blocked-logs${qs ? `?${qs}` : ''}`;
      const encodedPath = path.replace(/&/g, '%26');

      return await this.$http.get(
        `/redirect?app=MASTERTAGGO_V3&path=${encodedPath}`
      );
    }
  }
};

export {
  SEGMENTATION_AFILIO,
  SEGMENTATION_BET,
  MASTERTAG_HOST_BETCONNECT,
  MASTERTAG_HOST_BCONNECT,
  MASTERTAG_PUBLIC_SCRIPT_HOST_BETCONNECT,
  MASTERTAG_PUBLIC_SCRIPT_HOST_BCONNECT,
  mastertagPublicScriptHost,
  mastertagRouting,
  normalizeMastertagHostType
};
